import {useRouter} from "next-translate-routes/router";

export const useLocale = (): string => {
    const { locale } = useRouter()
    return locale === "default" ? "en" : locale || "en"
};
